<mat-toolbar>ユーザー管理</mat-toolbar>
<div class="mat-elevation-z2 search-form">
  <nav mat-tab-nav-bar [tabPanel]="userManageTabPanel">
    <a mat-tab-link *ngFor="let target of targets"
       (click)="activeTarget = target"
       [active]="activeTarget === target"
       [ngClass]="{'active-tab':activeTarget === target, 'inactive-tab':activeTarget !== target}"> {{target}} </a>
  </nav>
  <mat-tab-nav-panel #userManageTabPanel="matTabNavPanel">
    <form [formGroup]="teamsForm" (ngSubmit)="onSubmit()">
      <div class="main-form">
          <mat-form-field class="filterValue-form-field" appearance="fill">
            <input *ngIf="activeTarget === '所属部署'"
                  type="text"
                  class="text-form"
                  matInput
                  formControlName="filterValue"
                  [matAutocomplete]="autoGroup"
                  placeholder="検索">
            <input *ngIf="activeTarget !== '所属部署'"
                  type="text"
                  class="text-form"
                  matInput
                  formControlName="filterValue"
                  placeholder="検索">
            <span *ngIf="['氏名', 'ふりがな'].includes(activeTarget)" class="text-in-text-form" matSuffix>で始まる</span>
            <button *ngIf="this.teamsForm.value.filterValue" matSuffix mat-icon-button matTooltip="クリア" matTooltipPosition="right" type="button" aria-label="Clear" (click)="this.teamsForm.setValue({filterValue:''})" [disabled]="searching">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoGroup="matAutocomplete">
              <mat-optgroup *ngFor="let group of groupsOptions | async" [label]="group.department">
                <mat-option *ngFor="let name of group.names" [value]="name">
                  {{name}}
                </mat-option>
              </mat-optgroup>
            </mat-autocomplete>
          </mat-form-field>
          <button mat-icon-button matTooltip="検索" matTooltipPosition="right" color="primary" type="submit" [disabled]="searching">
            <mat-icon>search</mat-icon>
          </button>
        <button mat-raised-button type="button" (click)="loadAllUser()" color="primary" [disabled]="searching">
          すべてのユーザーを表示
        </button>
      </div>
    </form>
    <mat-divider></mat-divider>
    <div class="user-manage-buttons">
      <button class="addButton" mat-raised-button type="button" (click)="openDialog({ uid: '', displayName: '', authority: 0, key: '', manageAuthority: 0, id:0, email:'' })">
        新規ユーザー追加
      </button>
      <button class="importButton" mat-raised-button type="button" (click)="import()" *ngIf="isAdmin">
        CSVインポート
      </button>
      <button class="exportButton" mat-raised-button type="button" (click)="export()">
        CSVエクスポート({{dataSource?.data?.length}}件)
      </button>
    </div>
  </mat-tab-nav-panel>
</div>
<div class="mat-elevation-z8" [hidden]="isHidden">
  <table mat-table #table [dataSource]="dataSource" matSort aria-label="Elements">
    <!-- Id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>社員番号</th>
      <td mat-cell *matCellDef="let row">{{row?.id}}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>氏名</th>
      <td mat-cell *matCellDef="let row"><p class="kana">{{row?.kana}}</p><p class="displayName">{{row?.displayName}}</p></td>
    </ng-container>
    <ng-container matColumnDef="tagId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>カードID</th>
      <td mat-cell *matCellDef="let row">{{row?.key}}</td>
    </ng-container>

    <ng-container matColumnDef="team">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>所属部署</th>
      <td mat-cell *matCellDef="let row">{{row?.teamName}}</td>
    </ng-container>
    <ng-container matColumnDef="auth">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>権限</th>
      <td mat-cell *matCellDef="let row">{{getAuthName(row?.authority)}}</td>
    </ng-container>
    <ng-container matColumnDef="manageAuth">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>管理権限</th>
      <td mat-cell *matCellDef="let row">{{getManageAuthName(row?.manageAuthority)}}</td>
    </ng-container>
    <ng-container matColumnDef="normal-menu">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openDialog(row)">編集</button>
        </mat-menu>
      </td>
    </ng-container>
    <ng-container matColumnDef="admin-menu">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="openDialog(row)">編集</button>
            <button mat-menu-item (click)="resetPassword(row)">パスワードリセット</button>
            <button mat-menu-item (click)="delete(row)">削除</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator #paginator class="paginator" [length]="dataSource?.data?.length" [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 250]">
  </mat-paginator>
</div>
